// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@awc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { requestRmaInformationStyles } from "@awc/Overrides/Widgets/RequestRma/RequestRmaInformation";
import { color, mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

requestRmaInformationStyles.fieldWrapper = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
        css: css`
            width: 100%;
        `,
    }),
};

requestRmaInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

requestRmaInformationStyles.titleText = {
    ...mergeWithCss(xOrderInformationStyles.label, {
        css: css`
            width: 50%;
            margin-bottom: 16px;
        `,
    }),
};

requestRmaInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

requestRmaInformationStyles.billingAddressText = {
    ...mergeWithCss(xOrderInformationStyles.address?.heading, {
        as: "h2",
    }),
};

requestRmaInformationStyles.customerPOText = {
    ...xOrderInformationStyles.value,
};

requestRmaInformationStyles.billingInformationTitleText = {
    ...xOrderInformationStyles.address?.informationTitle,
};

requestRmaInformationStyles.wrapper = {
    width: [12, 12, 12, 4, 4],
    css: css`
        flex-direction: column;
        padding-bottom: 16px;
        &&& {
            margin-bottom: 24px;
        }
        ${xScreen("lte", "md")} {
            &&& {
                padding: 0;
                margin: 0;
            }
        }
    `,
};

requestRmaInformationStyles.billingGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        flex-direction: column;
        padding-bottom: 16px;
        &&& {
            margin-bottom: 24px;
        }
    `,
};

requestRmaInformationStyles.container = {
    gap: 0,
};
